import React from 'react';
import PropTypes from 'prop-types';
import { StyledPillText } from './styles';

export const PillText = ({ text, variant = 'light' }) => (
  <StyledPillText variant={variant}>{text}</StyledPillText>
);

PillText.displayName = 'PillText';
PillText.propTypes = {
  text: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(['light', 'dark']),
};
